import {useState, useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  Main,
  Timeline,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
  CoopReports,
  CombinedCoopReport,
  ToyotaCoopReport,
  MagnetForensicsCoopReport
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';

function HomePage({ mode, handleModeChange }: { mode: string, handleModeChange: () => void }) {
    return (
        <>
            <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
            <FadeIn transitionDuration={700}>
                <Main/>
                <Expertise/>
                <Timeline/>
                <Project/>
                <CoopReports/>
                <Contact/>
            </FadeIn>
            <Footer />
        </>
    );
}

function CombinedCoopReportPage() {
    // Separate state for coop report page that defaults to light
    const [coopMode, setCoopMode] = useState<string>('light');

    const handleCoopModeChange = () => {
        if (coopMode === 'dark') {
            setCoopMode('light');
        } else {
            setCoopMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);

    return (
        <div className={`main-container ${coopMode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
            <Navigation parentToChild={{mode: coopMode}} modeChange={handleCoopModeChange}/>
            <FadeIn transitionDuration={700}>
                <CombinedCoopReport/>
            </FadeIn>
            <Footer />
        </div>
    );
}

function ToyotaCoopReportPage() {
    // Separate state for coop report page that defaults to light
    const [coopMode, setCoopMode] = useState<string>('light');

    const handleCoopModeChange = () => {
        if (coopMode === 'dark') {
            setCoopMode('light');
        } else {
            setCoopMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);

    return (
        <div className={`main-container ${coopMode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
            <Navigation parentToChild={{mode: coopMode}} modeChange={handleCoopModeChange}/>
            <FadeIn transitionDuration={700}>
                <ToyotaCoopReport/>
            </FadeIn>
            <Footer />
        </div>
    );
}

function MagnetForensicsCoopReportPage() {
    // Separate state for coop report page that defaults to light
    const [coopMode, setCoopMode] = useState<string>('light');

    const handleCoopModeChange = () => {
        if (coopMode === 'dark') {
            setCoopMode('light');
        } else {
            setCoopMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);

    return (
        <div className={`main-container ${coopMode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
            <Navigation parentToChild={{mode: coopMode}} modeChange={handleCoopModeChange}/>
            <FadeIn transitionDuration={700}>
                <MagnetForensicsCoopReport/>
            </FadeIn>
            <Footer />
        </div>
    );
}

function App() {
    const [mode, setMode] = useState<string>('dark');

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);

    return (
        <Router 
            //basename="/react-portfolio-template" commenting out because vercel doesnt need a basename
            /*             future={{ not compatible with vercel?
                            v7_startTransition: true,
                            v7_relativeSplatPath: true
                        }} */
        >
            <Routes>
                <Route path="/" element={
                    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
                        <HomePage mode={mode} handleModeChange={handleModeChange} />
                    </div>
                } />
                <Route path="/combinedcoop" element={<CombinedCoopReportPage />} />
                <Route path="/toyotacoop" element={<ToyotaCoopReportPage />} />
                <Route path="/magnetcoop" element={<MagnetForensicsCoopReportPage />} />
            </Routes>
        </Router>
    );
}

export default App;